const PageTitle = ({ title, caption }) => {
  return (
    <div className="">
      <div className="text-primary font-semibold text-md">
        <span className="text-3xl"></span> {title}
      </div>
      <div className="">{caption}.</div>
    </div>
  );
};

export default PageTitle;
